import { Select, SelectProps } from 'antd';
import { FC, useEffect, useMemo } from 'react';
import 'flag-icons/less/flag-icons.less';
import { countryAndPhoneCode, getCountryInfoFromCode } from './country-and-phone-code-utils';
import { useGeolocationIp } from 'hooks/useGeolocationIp';

export const CountryInput: FC<SelectProps> = (props) => {
  const { value, onChange } = props;
  const geo = useGeolocationIp();
  const options = useMemo(
    () =>
      countryAndPhoneCode.map((item) => ({
        label: item.name,
        value: item.code,
      })),
    [],
  );

  useEffect(() => {
    if (geo?.country && !value) {
      const country = getCountryInfoFromCode(geo.country);
      onChange?.(geo.country, {
        label: country?.name,
        value: country?.code,
      });
    }
  }, [geo]);

  return (
    <Select {...props} showSearch optionFilterProp="label">
      {options?.map((option) => (
        <Select.Option key={option.value} value={option.value} label={option.label}>
          <div>
            <span className={`fi fi-${option.value.toLowerCase()}`} style={{ fontSize: 16, marginRight: 10 }} />
            {option.label}
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};
